// 包含所有模块的操作名称 协作开发,防止操作名称重复, 起到一个约束作用
export default {
  SET_ISLOGIN: "SET_ISLOGIN",
  SET_USERID: "SET_USERID",
  SET_CONT_COURSE: "SET_CONT_COURSE",
  SET_COURSE_CARD: "SET_COURSE_CARD",
  SET_SELECT_ALL: "SET_SELECT_ALL",
  SET_SELECT_COURSE_IDS: "SET_SELECT_COURSE_IDS",
  SET_SELECT_CLASS_IDS: "SET_SELECT_CLASS_IDS",
  SET_SCROLL_POSITION: "SET_SCROLL_POSITION",
  SET_IS_CHANGE_RAW_PRODUCT: "SET_IS_CHANGE_RAW_PRODUCT",
  // extensionSignUp
};
